(function () {
  "use strict";

  angular
    .module("tikonApp")
    .controller("ReserveServicesController", ReserveServicesController);

  ReserveServicesController.$inject = ["$timeout", "$state"];

  function ReserveServicesController($timeout, $state) {
      function loadReserveServices() {
            var reserveServices = document.getElementById('reserve-services');
            reserveServices.addEventListener('backToPrevVersion', function(e){
                $state.go("supplierPanel-v2.serviceItemList", { type: "services" }) 
            })
             reserveServices.addEventListener('toServiceCategories', function(e){
                $state.go("supplierPanel-v2.serviceCategories")
            })

        }
        $timeout(loadReserveServices, 100)

  }
})();


